import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner2 from '../../assets/banner2.png'

import { Container, Title, Content, Table } from './styles'

export function TemNoParqueContent() {
 const title = 'Tem no Parque'
 const subtitle = 'Conteúdo da página'

 const fields = useMemo(
  () => [
   {
    id: 'Conteúdo Tem no Parque',
    b_id: String,
    imagem: String,
    text: String,
    page: String,
    galleryTitle: String,
    gallery: Array,
    show_gallery: Number,
    videosTitle: String,
    videos: String,
    status: Number
   }
  ],
  []
 )

 const {
  contentTemNoParque,
  setContentTemNoParque,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(contentTemNoParque.length / limit)

 const loadContent = useCallback(async () => {
  try {
   const response = await api.get('temnoparque')

   setContentTemNoParque(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar o conteúdo ')
  }
 }, [setContentTemNoParque])

 useEffect(() => {
  loadContent()
 }, [loadContent])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadContent}
     fields={fields}
     name="temnoparque"
     title="Conteúdo da página - Tem no parque"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadContent}
     id={id}
     name="temnoparque"
     title="Conteúdo da página - Tem no parque"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadContent}
     id={id}
     name="temnoparque"
     folder="temnoparque"
     title="Conteúdo da página - Tem no parque"
    />
   )}

   <Header title={title} subtitle={subtitle} />
   <Container>
    <Title>Gerenciador de conteúdo</Title>
    {contentTemNoParque.length <= 0 ? (
     <>Nenhum conteúdo cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Imagem</th>
         <th>Página</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {contentTemNoParque &&
         contentTemNoParque.slice(offset, offset + limit).map(content => (
          <tr key={content.id}>
           <td>{content.id}</td>
           <td>
            <div>
             {content.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/temnoparque/${content.file}`}
               alt={content.page}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{content.page}</td>
           <td>
            {content.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(content.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(content.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações do banner</Title>
    <Content>
     <div>
      <img src={banner2} alt="Banner foto + texto" />
      <h3>Banner foto + texto</h3>
      <p>Formato: 1106 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
